export default __webpack_public_path__ + "static/media/nn2.f3462c15.svg";